/**
 * #1024 - buying a plan without the offline-socket (Gateway) entitlement ends the account's Gateway
 * (the pod's license check fails and it shuts down after a 3h grace) and the sends queued on it stall.
 * Decide, before checkout, whether to show the "Gateway is Pro-only" confirmation.
 */

export interface GatewayImpactLike {
  hasGateway: boolean;
  pendingCount: number;
}

export interface GatewayWarningInput {
  /** The plan the user is on now includes the Gateway (so they would LOSE it). */
  currentIncludesGateway: boolean;
  /** The plan being bought includes the Gateway. */
  targetIncludesGateway: boolean;
  /** The caller's Gateway state; undefined while loading or if the lookup failed. */
  impact: GatewayImpactLike | undefined;
}

/** Only warn when something is actually lost: a Gateway exists and the move takes the entitlement away.
 *  An unknown impact (loading / error) never blocks the purchase. */
export function shouldWarnGatewayLoss({ currentIncludesGateway, targetIncludesGateway, impact }: GatewayWarningInput): boolean {
  return currentIncludesGateway && !targetIncludesGateway && impact?.hasGateway === true;
}
